/* @flow */
import React, {Component, Fragment} from 'react';
import {DropdownControlled} from '@homeaway/react-dropdown';
import {Button} from '@homeaway/react-buttons';
import MoreFiltersPanel from '../MoreFiltersPanel/MoreFiltersPanel';
import FilteredCountDataProvider from '../FilteredCountDataProvider/FilteredCountDataProvider';
import {filterCount} from '../../utils/filterCount';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {SVGIcon} from '@homeaway/react-svg';
import {FILTER__16} from '@homeaway/svg-defs';
import './MoreFiltersPanelDropdown.less';

import type {Node} from 'react';
import type {SearchParamsType} from '../../reducers/searchParams';
import type {State as ReduxState} from '../../reducers/index';

import type {CallbackProps as FilteredCountDataShape} from '../FilteredCountDataProvider/FilteredCountDataProvider';

type OwnProps = {
    onCancel: () => void,
    toggleDropdown: () => void,
    open: boolean,
    onApplyFilters: (void) => void,
    onInputParamsRangeFilterChange: (SearchParamsType) => void,
    searchResultsLoading: boolean,
    topBannersHeight: number
};

type StateProps = {
    numFiltersPanel: number
};

type Props = OwnProps & StateProps;

const MORE_FILTERS_ID = 'moreFilters';

export class MoreFiltersPanelDropdown extends Component<Props> {
    renderMoreFiltersPanel = ({
        filterGroups,
        resultsCount
    }: FilteredCountDataShape) => {
        const {
            onApplyFilters,
            onInputParamsRangeFilterChange,
            onCancel
        } = this.props;

        return (
            <MoreFiltersPanel
                onApplyFilters={onApplyFilters}
                filterGroups={filterGroups}
                resultsCount={resultsCount}
                onInputParamsRangeFilterChange={onInputParamsRangeFilterChange}
                onCancel={onCancel}
            />
        );
    };

    renderButtonLabel = () => {
        return (
            <Fragment>
                <SVGIcon
                    markup={FILTER__16}
                    aria-hidden
                    className="FilterIcon"
                />
                <FormattedMessage
                    id={'moreFiltersLabel'}
                    defaultMessage={'More Filters'}
                >
                    {(txt: Node): Node =>
                        `${String(txt)} ${filterCount(
                            this.props.numFiltersPanel
                        )}`
                    }
                </FormattedMessage>
            </Fragment>
        );
    };

    render() {
        const {
            renderMoreFiltersPanel,
            props: {open, onApplyFilters, toggleDropdown, searchResultsLoading}
        } = this;

        return (
            <DropdownControlled
                id={MORE_FILTERS_ID}
                label={this.renderButtonLabel()}
                customToggle={
                    <Button
                        id={MORE_FILTERS_ID}
                        label={this.renderButtonLabel()}
                    />
                }
                onDropdownClick={toggleDropdown}
                onBlur={onApplyFilters}
                onTouch={onApplyFilters}
                open={open}
                noArrow
                className="MoreFilters__btn"
            >
                {open && (
                    <FilteredCountDataProvider
                        children={renderMoreFiltersPanel}
                        searchResultsLoading={searchResultsLoading}
                    />
                )}
            </DropdownControlled>
        );
    }
}

const mapStateToProps = ({searchParams: {numFiltersPanel}}: ReduxState) => ({
    numFiltersPanel
});

export default connect(mapStateToProps, null)(MoreFiltersPanelDropdown);
